export default "__VITE_ASSET__52667688__"